<template>
  <el-tooltip class="bounce-capsule">
    <div>
      <span class="label"><i class="ddi ddi-warning" /></span>
      <span class="message">Email could not be delivered</span>
    </div>
    <template #content>
      <div>
        <span>Could not deliver email to:</span>
        <br>
        <strong>{{ bounceInfo.bouncedEmail}}</strong>
        <br>
        <span>{{ bounceInfo.description }}</span>
      </div>
    </template>
  </el-tooltip>
</template>

<script lang="ts">
import { IBounceInfo } from '@/types/data-objects/item-histories'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BounceCapsule',

  props: {
    bounceInfo: {
      type: Object as () => IBounceInfo,
      required: true,
    },
  },
})
</script>

<style lang="scss">
.bounce-capsule {
  display: flex;
  align-items: center;
  border-radius: 14px;
  padding: 2px 12px;
  overflow: hidden;
  border: solid 1px $color--red;
  cursor: default;

  &:hover {
    background-color: var(--color-background-secondary);
  }

  .label {
    font-size: 13px;
    padding-right: 6px;
    color: $color--red;
  }

  .message {
    @include lettering--p-sm;
    color: $color--red;
  }
}
</style>
